import { render } from "./Docs.vue?vue&type=template&id=a5ef7736"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=a5ef7736&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__